<template>
  <div class="col-12">
    <div class="card survey-panel">
      <div class="card-body">
        <div class="row g-4">
          <div v-if="stepTip" class="col-12">
            <div class="alert alert-info border-0 mb-0">
              <div class="fw-semibold mb-2">Gut zu wissen</div>
              <div class="small text-body mb-0" v-html="stepTip"></div>
            </div>
          </div>
          <div class="col-12">
            <template :key="key"
                      v-for="(child, key) in surveyStore.currentConfig.steps[surveyStore.currentStep]">
              <component
                v-if="child && child.component"
                :is="child.component"
                v-bind="standortModelBindings(key, child)"
                :errors="errors"
                :type="child.type"
                :options="child.options || {}"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useSurveyStore} from "@/stores/survey";
export default {
  components: {},
  setup() {
    return {
      surveyStore: useSurveyStore(),
    }
  },
  data() {
    return {}
  },
  props: {
    errors: Object,
  },
  computed: {
    stepTip() {
      const currentStep = this.surveyStore.currentConfig.steps?.[this.surveyStore.currentStep]
      if (!currentStep) {
        return null
      }

      const stepWithTip = Object.values(currentStep)
        .find(child => child?.options?.tipp)

      if (!stepWithTip) {
        return null
      }

      const storeKey = stepWithTip.options?.storeKey
      if (storeKey && this.surveyStore.data[storeKey]?.select === 'true') {
        return null
      }

      return stepWithTip.options.tipp
    }
  },
  methods: {
    standortModelBindings(key, child) {
      if (key === 'standort' || child?.name === 'standort') {
        return {
          modelValue: this.surveyStore.data.standort,
          'onUpdate:modelValue': (v) => {
            this.surveyStore.data.standort = v
          },
        }
      }
      return {}
    },
  },
}
</script>
